
import React, { useEffect, useState } from 'react'
import DetailContainer from '../MainPage/common/DetailContainer'
import { images } from '../common/images';
import { messages } from '../common/notification';
import { deviceControl, deviceDetails } from '../common/ApiCall';

function ACStatusDetailContainer({ time, selectedDeviceSelectedDayData, selectedDate, deviceId }) {
  const [deviceDetail, setDeviceDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const getDeviceDetail = () => {
    deviceDetails(deviceId)
      .then((res) => {
        setDeviceDetails(res);
        setLoading(false)
      })
      .catch((err) => {
        setDeviceDetails({});
        setLoading(false)
      });
  }
  useEffect(() => {
    if (selectedDeviceSelectedDayData.length == 0) return;
    getDeviceDetail()

  }, [deviceId]);
  if (selectedDeviceSelectedDayData.length == 0) return;

  const isConnected = selectedDeviceSelectedDayData[0].connected;
  const hasStateLogs = selectedDeviceSelectedDayData[0].stateLogs?.length > 0;
  let isLastLogOff = true

  const isDifferentDate = (new Date(selectedDate).setHours(0, 0, 0, 0) !== new Date().setHours(0, 0, 0, 0))
  const value =   selectedDeviceSelectedDayData[0]?.deviceId?.startsWith("KP")?"On":isDifferentDate || !isConnected ? "Offline" : (deviceDetail.applianceState === 0 ? "Off" : "On")
  let nameObj = {
    'M280246': 'Ac Status',
    "M240054": 'Motion Status'
  }

  return (
    <DetailContainer
      name={nameObj[deviceId] ? nameObj[deviceId] : "Appliance Status"}
      value={loading ? <div class="spinner-border" role="status">
        <span class="sr-only"></span>
      </div> : value}
      {...(!loading && {
        textColor: value === 'Off' ? '#FF0000' : 'rgb(26, 200, 33)',
      })}
      OnClick={() => {
        if (value === "Off") {
          setLoading(true)
          deviceControl(deviceId, 100).then((res) => {
            if (res) {
              getDeviceDetail()
            } else {
              setLoading(false)
            }
          })
        } else {
          setLoading(true)
          deviceControl(deviceId, 0).then((res) => {
            if (res) {
              getDeviceDetail()
            } else {
              setLoading(false)
            }
          })
        }
      }}
      styleValue={{ cursor: value === 'Offline' ? '' : 'pointer' }}
      time={time}
      color={"rgba(118, 190, 194, 0.10)"}
      borderColor={"#76BEC2"}
      image={images.ac}
    />
  )
}

export default ACStatusDetailContainer